import React from 'react';
import ViewPage from './View'


function App() {
  return (
    <div className="App">
      <ViewPage />
    </div>
  );
}

export default App;
